
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Notify } from "quasar";

@Component({
  components: {}
})
export default class DireccionDialogComponent extends Vue {
  @Prop({ type: Object, required: true }) direccion!: Record<string, any>;
  @Prop({ type: Boolean, required: true }) show!: boolean;

  internalShow = false;

  private async mounted() {
    this.internalShow = this.show;
  }

  @Watch("show")
  onShowChange(val: boolean) {
    this.internalShow = val;
  }

  emitClose() {
    this.$emit("update:show", false);
    this.$emit("close");
  }
}
